/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import classnames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import { Suffix } from 'web-ui-components/lib/atoms/forms';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { VisuallyHiddenBody } from 'web-ui-components/lib/typography/body';
import styles from './DateField.styles';

export const isFocusInCurrentTarget = ({ relatedTarget = null, currentTarget = null }) => {
	if (!relatedTarget || !currentTarget) return false;

	let node = relatedTarget.parentNode;

	while (node !== null) {
		if (node === currentTarget) return true;
		node = node.parentNode;
	}

	return false;
};

class DateField extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
		};

		this.toggleCalendar = this.toggleCalendar.bind(this);
		this.handleOnBlur = this.handleOnBlur.bind(this);
		this.handleOnFocus = this.handleOnFocus.bind(this);
	}

	toggleCalendar(event) {
		event.preventDefault();
		event.stopPropagation();

		this.setState(
			(prevState) => ({ isOpen: !prevState.isOpen }),
			() => {
				if (this.state.isOpen) {
					this.datepicker.setFocus();
				}
			}
		);
	}

	handleOnBlur(event) {
		if (!isFocusInCurrentTarget(event)) {
			this.setState({ isOpen: false });
			this.props.onBlur();
		}
	}

	handleOnFocus() {
		this.setState({ isOpen: true });
		this.props.onFocus();
	}

	render() {
		const { id, onClick, onChange, disabled, className, dateFormat, minDate, maxDate, selectedDate, includeDates } =
			this.props;

		return (
			<div role="button" className={className} onClick={onClick} onBlur={(e) => this.handleOnBlur(e)}>
				<label htmlFor={id}>
					<VisuallyHiddenBody>Date</VisuallyHiddenBody>
				</label>
				<DatePicker
					id={id}
					ref={(datepicker) => {
						this.datepicker = datepicker;
					}}
					dateFormat={dateFormat}
					minDate={minDate}
					maxDate={maxDate}
					onChange={onChange}
					onFocus={this.handleOnFocus}
					className={classnames(styles.dateWrapperVMStyle, 'c-a-input c-a-input--text has-suffix')}
					selected={selectedDate}
					disabled={disabled}
					includeDates={includeDates}
				/>
				<span
					role="button"
					tabIndex={0}
					onClick={(e) => this.toggleCalendar(e)}
					onKeyDown={() => {}}
					onKeyUp={() => {}}
					onKeyPress={() => {}}
					disabled={disabled}
				>
					<Suffix>
						<Icon iconType="CalendarOutlineSmall" />
					</Suffix>
				</span>
			</div>
		);
	}
}

DateField.propTypes = {
	id: PropTypes.string.isRequired,
	dateFormat: PropTypes.string.isRequired,
	minDate: PropTypes.instanceOf(moment),
	maxDate: PropTypes.instanceOf(moment),
	selectedDate: PropTypes.instanceOf(moment).isRequired,
	onChange: PropTypes.func.isRequired,
	onClick: PropTypes.func,
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,
	className: PropTypes.string,
	disabled: PropTypes.bool,
	includeDates: PropTypes.arrayOf(PropTypes.instanceOf(moment)),
};

DateField.defaultProps = {
	onClick: () => {},
	onFocus: () => {},
	onBlur: () => {},
};

export default DateField;
